import React from 'react';
import sortBy from 'lodash.sortby';

let Quote = require('../Managers/Quote');
let ProductCover = require('../Managers/ProductCover');

const CoverButtons = React.createClass({
    propTypes: {
        covers: React.PropTypes.array.isRequired,
        callBackRiskCheck: React.PropTypes.func,
        setActiveCallback: React.PropTypes.func,
    },

    getInitialState() {
        return {
            primaryCover: (ProductCover.getJPK() > 0) ? ProductCover.getJPK() : 0,
            secondaryCover: (ProductCover.getSPK() > 0) ? ProductCover.getSPK() : 0,
            noSecondaryCover: false,
            isMobile: (window.innerWidth < 544) ? true : false
        };
    },

    componentWillMount() {
        // If we've got a 0 value on secondary cover, we need to enable the
        // 'no thanks' button.
        if (this.state.secondaryCover === 0) {
            this.setState({ noSecondaryCover: true });
        }
    },

    setActive(jpk){
        this.setState({
            primaryCover: jpk,
            secondaryCover: (jpk <= 8) ? 0 : this.state.secondaryCover
        });

        // There is no secondary journey permutation value if jpk is less than 8 i.e. building & contents, buildings only, contents only
        ProductCover.setJPK(jpk);

        if (jpk <= 8) {
            // dont need to call Quote.getQuestions() in here, as setSecondary
            // does it for us
            this.setSecondary(0);
        } else {
            ProductCover.setCovers(jpk, ProductCover.getSPK());
            Quote.getQuestions();
        }
        this.props.setActiveCallback();
        this.props.callBackRiskCheck();
    },

    setSecondary(spk) {
        if (spk !== 0) {
            this.setState({
                secondaryCover: spk,
                noSecondaryCover: false,
            });

            // Set the secondary journey permutation key
            ProductCover.setSPK(spk);

            // Stop (race condition) duplicate calls to this.getQuestions
            if (spk > 0) {
                Quote.getQuestions();
            }

            // Set product covers (which are just questions with answers in the Quote body paramaters)
            ProductCover.setCovers(ProductCover.getJPK(), spk);
        } else {
            // We've pushed a a secondary cover with a value of 0 by saying
            // 'no thanks' in a product fly-out or similar, so make sure we get
            // the right questions
            this.setState({
                secondaryCover: 0,
                noSecondaryCover: true,
               
            });

            ProductCover.setSPK(0);
            Quote.getQuestions();
            ProductCover.setCovers(ProductCover.getJPK(), 0);
        }
        this.props.callBackRiskCheck();
    },
   
    render() {
        let newCovers = [];
        if(this.state.isMobile) {
            newCovers = sortBy(this.props.covers, 'mobile_sort', function(n) {
                return Math.sin(n);
            });
        } else {
            newCovers = this.props.covers;
        }
       
        let coverbuttonsArray = [];
        {newCovers.map(function(cover) {

            let iconUrl = (cover.journey_permutation_key == this.state.primaryCover) ? 'url(/images/' + cover.icon + '-hover.svg)' : 'url(/images/' + cover.icon + '.svg)';
            let iconCss = {
                backgroundImage: iconUrl
            };

            coverbuttonsArray.push(
                <div
                    className={cover.divClass + " choice-container-wrapper"}
                    key={cover.sort}
                    onClick={this.setActive.bind(this, cover.journey_permutation_key)}
                >
                    <div className={cover.divClass}>
                        <div className={cover.journey_permutation_key == this.state.primaryCover ? cover.buttonClass + " selected" : cover.buttonClass}>
                            {cover.name}
                            <i className="icon test" style={iconCss} />
                        </div>
                    </div>
                </div>
            );
        }, this);}

        return (

            <div className="product-selection-buttons" ref="coverbuttons">
                {coverbuttonsArray}
            </div>
        );
    }
});

export default CoverButtons;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/CoverButtons.js
 **/